import { Paginated } from "@/@types/paginated";
import { Tags } from "../enum/tags";
import { apiSlice } from "./http";
import {
  ICashBalanceReport,
  IRecordsCashBalance,
  IRequestParams,
  IRequestParamsRecords,
  IRegional,
} from "@/@types/cash-balance";

export const cashBalanceApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getCashBalanceReport: builder.query<
      ICashBalanceReport,
      { params: IRequestParams }
    >({
      query: ({ params }) => {
        const urlParams = new URLSearchParams(
          params as unknown as Record<string, string>
        );
        return {
          url: `/cash-balance/report?${urlParams.toString()}`,
          method: "GET",
        };
      },
      providesTags: [Tags.CASH_BALANCE],
    }),

    getLatestCashBalance: builder.query<ICashBalanceReport, void>({
      query: () => ({
        url: "/cash-balance/latest",
        method: "GET",
      }),
    }),

    getRecordsCashBalance: builder.query<
      Paginated<IRecordsCashBalance>,
      IRequestParamsRecords
    >({
      query: ({ meta, created_at_start, created_at_end, regional_id, search, store_code }) => {
        const paramsObj = {
          search,
          regional_id,
          created_at_start,
          created_at_end,
          store_code,
          page: meta.page?.toString(),
          perPage: meta.perPage?.toString(),
        };

        const params = new URLSearchParams(
          Object.entries(paramsObj)
            .filter(([_, value]) => value !== undefined)
            .reduce(
              (acc, [key, value]) => ({ ...acc, [key]: value as string }),
              {}
            )
        );

        return {
          url: `/cash-balance/records?${params.toString()}`,
          method: "GET",
        };
      },
    }),
    getRegionalsCashBalance: builder.query<IRegional, void>({
      query: () => ({
        url: "/cash-balance/regionals",
        method: "GET",
      }),
    }),
    getLastCashBalanceByStore: builder.query<
      any, 
      { storeId: number }
    >({
      query: ({ storeId }) => ({
        url: `/cash-balance/last-cash-balance/?storeId=${storeId}`,
        method: "GET",
      }),
      providesTags: [Tags.CASH_BALANCE],
    }),

  }),
});

export const {
  useGetCashBalanceReportQuery,
  useGetLatestCashBalanceQuery,
  useLazyGetCashBalanceReportQuery,
  useGetRecordsCashBalanceQuery,
  useGetRegionalsCashBalanceQuery,
  useGetLastCashBalanceByStoreQuery
} = cashBalanceApi;
